import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import Kids from "./kids";
import KidSponsorModal from "./components/KidSponsorModal";
import KidProfileModal from "./components/KidProfileModal";

/**
 * Shared profile link (/kid/:kid_id): show profile with fresh sponsorship status.
 * Sponsor action opens checkout; already-sponsored kids show "Already Sponsored".
 */
const KidLinkLanding = () => {
  const { kid_id } = useParams();
  const navigate = useNavigate();
  const [showProfileModal, setShowProfileModal] = useState(!!kid_id);
  const [showSponsorModal, setShowSponsorModal] = useState(false);

  const handleCloseAll = () => {
    setShowProfileModal(false);
    setShowSponsorModal(false);
    navigate("/", { replace: true });
  };

  return (
    <Layout>
      <Kids />
      <KidProfileModal
        isOpen={showProfileModal}
        onClose={handleCloseAll}
        kidId={kid_id}
        onSponsorClick={(id) => {
          setShowProfileModal(false);
          setShowSponsorModal(true);
        }}
      />
      <KidSponsorModal
        isOpen={showSponsorModal}
        onClose={handleCloseAll}
        kidId={kid_id}
        onBackToProfile={() => {
          setShowSponsorModal(false);
          setShowProfileModal(true);
        }}
      />
    </Layout>
  );
};

export default KidLinkLanding;
